<div class="footer">
  <div class="container">
    <p>
      <span class="fw-bold">{{ addressSpan }} </span>
      {{ addressText }}
    </p>
    <p>
      <span class="fw-bold">{{ phoneSpan }} </span>
      {{ phoneText }}
    </p>
    <p>
      <span class="fw-bold">{{ faxSpan }}</span>
      {{ faxText }}
    </p>
  </div>
</div>
